module.exports = __webpack_public_path__ + "static/language-selector-screen1@2x-0c3551dadace12a4562bc526167dc459.png";